var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-autocomplete',{ref:"select",attrs:{"value":_vm.selected.name,"data":_vm.options,"open-on-focus":true,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('city')}...`,"field":"name"},on:{"select":_vm.onSelect,"typing":_vm.onSearch}},[_c('template',{slot:"empty"},[_vm._v(" "+_vm._s(_vm.$tc('noResult'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }